"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25],{

/***/ 9817:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-green.2a508d0e.png","height":911,"width":3950,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEUaqFYZp1UZqFUdqVhrotV3AAAABHRSTlMsFg8hii2lTwAAAAlwSFlzAAAOvwAADr8BOAVTJAAAABdJREFUCJljYGBgZGJiZGRiYGBgZgABAACUAA1o9/y9AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 1025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zn": function() { return /* reexport */ MainLayout_MainLayout; },
  "$0": function() { return /* reexport */ Section_Section; },
  "vV": function() { return /* reexport */ Section2_Section2; }
});

// UNUSED EXPORTS: useMainLayoutStore

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
;// CONCATENATED MODULE: ./src/layouts/common/Section/Section.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


/**
 * Section component
 */ var Section = (0,chakra_ui_system_esm/* forwardRef */.Gp)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, _objectSpread({
        as: "section",
        ref: ref,
        maxW: "container.lg",
        my: 4,
        mx: "auto",
        textAlign: "center"
    }, props, {
        children: props.children
    }));
});
/* harmony default export */ var Section_Section = (Section);

;// CONCATENATED MODULE: ./src/layouts/common/Section/index.ts


;// CONCATENATED MODULE: ./src/layouts/common/Section2/Section2.tsx
function Section2_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Section2_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Section2_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var Section2 = (0,chakra_ui_system_esm/* forwardRef */.Gp)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, Section2_objectSpread({
        as: "section",
        ref: ref,
        maxW: "container.lg",
        h: "100vh",
        my: 4
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            h: "full",
            children: props.children
        })
    }));
});
/* harmony default export */ var Section2_Section2 = (Section2);

;// CONCATENATED MODULE: ./src/layouts/common/Section2/index.ts


;// CONCATENATED MODULE: ./src/layouts/common/index.ts



// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/chakra-ui-color-mode.esm.js
var chakra_ui_color_mode_esm = __webpack_require__(949);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/visually-hidden/dist/chakra-ui-visually-hidden.esm.js
var chakra_ui_visually_hidden_esm = __webpack_require__(1358);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(3750);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/yup-phone/dist/yup-phone.umd.js
var yup_phone_umd = __webpack_require__(8269);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/chakra-ui-toast.esm.js + 4 modules
var chakra_ui_toast_esm = __webpack_require__(3238);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js
var chakra_ui_form_control_esm = __webpack_require__(9762);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(6723);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./src/apollo/mutation/index.ts + 13 modules
var mutation = __webpack_require__(8042);
// EXTERNAL MODULE: ./src/components/index.ts + 50 modules
var components = __webpack_require__(2836);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(4853);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 2 modules
var useMutation = __webpack_require__(1068);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(5496);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/Footer/FooterLetsTalkForm.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function FooterLetsTalkForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FooterLetsTalkForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FooterLetsTalkForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var schema = es.object({
    name: es.string().required(),
    email: es.string().email().required(),
    phone: es.string().required(),
    projectDescription: es.string().required()
});
var FooterLetsTalkForm = function() {
    var ref4, ref1;
    var reCaptchaRef = (0,react.useRef)();
    var toast = (0,chakra_ui_toast_esm/* useToast */.pm)();
    var ref2 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(schema)
    }), register = ref2.register, handleSubmit = ref2.handleSubmit, reset = ref2.reset, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var ref3 = _slicedToArray((0,useMutation/* useMutation */.D)(mutation/* CONTACT_US */.Y), 2), contactUs = ref3[0], loading = ref3[1].loading;
    var onSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(formData) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return reCaptchaRef.current.executeAsync();
                    case 3:
                        _ctx.next = 5;
                        return contactUs({
                            variables: {
                                contactUsInput: formData
                            }
                        });
                    case 5:
                        reset();
                        toast({
                            status: 'success',
                            render: function() {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    border: "1px",
                                    borderColor: "primary",
                                    p: 6,
                                    rounded: "lg",
                                    bgColor: "black",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        color: "white",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        children: "Message Sent"
                                    })
                                });
                            }
                        });
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        toast({
                            containerStyle: {
                                marginBottom: '100px'
                            },
                            status: 'error',
                            render: function() {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    border: "1px",
                                    borderColor: "red.500",
                                    p: 6,
                                    rounded: "lg",
                                    bgColor: "black",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        color: "white",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        children: "Something went wrong"
                                    })
                                });
                            }
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = errors.email) === null || ref === void 0 ? void 0 : ref.message) === 'email must be a valid email' && !toast.isActive('email-error')) {
            toast({
                id: 'email-error',
                status: 'error',
                render: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        border: "1px",
                        borderColor: "red.500",
                        p: 6,
                        rounded: "lg",
                        bgColor: "black",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            color: "white",
                            fontWeight: "bold",
                            textAlign: "center",
                            children: "Invalid email address"
                        })
                    });
                }
            });
        }
    }, [
        (ref4 = errors.email) === null || ref4 === void 0 ? void 0 : ref4.message,
        (ref1 = errors.phone) === null || ref1 === void 0 ? void 0 : ref1.message,
        toast,
        isSubmitting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Form */.l0, {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                ref: reCaptchaRef,
                size: "invisible",
                sitekey: "6Lc4XT4eAAAAAN-tSB27-ZclotjjPpVU80dTi1-Q"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: "6",
                mb: "12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormControl */.NI, {
                        isInvalid: !!errors.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, FooterLetsTalkForm_objectSpread({
                            placeholder: "Name",
                            variant: "underline",
                            size: "lg"
                        }, register('name', {
                            required: true
                        })))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormControl */.NI, {
                        isInvalid: !!errors.email,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, FooterLetsTalkForm_objectSpread({
                            placeholder: "Email",
                            type: "email",
                            variant: "underline",
                            size: "lg"
                        }, register('email', {
                            required: true
                        })))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormControl */.NI, {
                        isInvalid: !!errors.phone,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, FooterLetsTalkForm_objectSpread({
                            placeholder: "Phone",
                            variant: "underline",
                            type: "tel",
                            size: "lg"
                        }, register('phone', {
                            required: true
                        })))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormControl */.NI, {
                        isInvalid: !!errors.projectDescription,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, FooterLetsTalkForm_objectSpread({
                            placeholder: "Project Details",
                            variant: "underline",
                            size: "lg"
                        }, register('projectDescription', {
                            required: true
                        })))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                    id: "footer-cta-form-submit",
                    size: "lg",
                    isFullWidth: true,
                    maxW: "400px",
                    type: "submit",
                    isLoading: loading,
                    children: "Send Request"
                })
            })
        ]
    });
};
/* harmony default export */ var Footer_FooterLetsTalkForm = (FooterLetsTalkForm);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(9352);
;// CONCATENATED MODULE: ./src/assets/images/web-signature.svg
/* harmony default export */ var web_signature = ({"src":"/_next/static/media/web-signature.08a9ba81.svg","height":355,"width":665});
;// CONCATENATED MODULE: ./src/hooks/useWindowSize.ts

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    var ref = (0,react.useState)({
        width: 0,
        height: 0
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}
/* harmony default export */ var hooks_useWindowSize = (useWindowSize);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/Footer/Footer.tsx











var Footer = function(param) {
    var _footerTheme = param.footerTheme, footerTheme = _footerTheme === void 0 ? 'dark' : _footerTheme, footerSticky = param.footerSticky;
    var ref = (0,react.useState)(false), isStickyFooter = ref[0], setIsStickyFooter = ref[1];
    var ref1 = hooks_useWindowSize(), height = ref1.height, width = ref1.width;
    (0,react.useEffect)(function() {
        setIsStickyFooter(height >= 759 && width >= 992);
    }, [
        height,
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        as: "footer",
        flex: 1,
        minH: "100vh",
        w: "full",
        position: footerSticky !== undefined ? footerSticky ? 'sticky' : 'static' : isStickyFooter ? 'sticky' : 'static',
        bottom: 0,
        left: 0,
        zIndex: 0,
        flexDirection: "column",
        children: [
            footerTheme === 'dark' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_color_mode_esm/* DarkMode */.t7, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                    flex: 1,
                    h: "full",
                    bgColor: "black",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                        display: "flex",
                        maxW: "container.xl",
                        py: "10",
                        justifyContent: "center",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                textAlign: "center",
                                size: "2xl",
                                mb: "6",
                                color: "white",
                                _mediaDark: {
                                    color: 'white'
                                },
                                children: "Let's Talk"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                as: "h3",
                                textAlign: "center",
                                color: "white",
                                _mediaDark: {
                                    color: 'white'
                                },
                                fontWeight: "normal",
                                mb: 8,
                                children: "Get a free confidential consultation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, {
                                mx: "auto",
                                maxW: "container.md",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterLetsTalkForm, {})
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_color_mode_esm/* LightMode */.iJ, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                    flex: 1,
                    h: "full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                        display: "flex",
                        maxW: "container.xl",
                        pt: "100px",
                        pb: "10",
                        justifyContent: "center",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                textAlign: "center",
                                size: "2xl",
                                mb: "6",
                                children: "Let's Talk"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                as: "h3",
                                textAlign: "center",
                                color: "gray.800",
                                _dark: {
                                    color: 'white'
                                },
                                fontWeight: "normal",
                                mb: 8,
                                children: "Get a free confidential consultation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, {
                                mx: "auto",
                                maxW: "container.md",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterLetsTalkForm, {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                flexShrink: 0,
                borderTop: "4px",
                borderColor: "primary",
                px: "4",
                bg: "black",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                    maxW: "container.xl",
                    display: "flex",
                    minH: {
                        base: '400px',
                        md: 'unset'
                    },
                    flexDirection: {
                        base: 'column',
                        lg: 'row'
                    },
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                            flex: "1",
                            alignItems: {
                                base: 'center',
                                lg: 'flex-start'
                            },
                            spacing: "4",
                            py: "8",
                            order: {
                                base: 3,
                                lg: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/privacy-policy",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        as: "a",
                                        color: "white",
                                        children: "Privacy Policy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    color: "gray.500",
                                    children: "\xa9 Chacra Software Solutions"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    color: "gray.500",
                                    children: "All Rights Reserved"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            flex: "1",
                            order: {
                                base: 1,
                                lg: 2
                            },
                            py: {
                                base: 8,
                                lg: 0
                            },
                            w: "full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                position: "relative",
                                h: "120px",
                                w: "full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: web_signature,
                                    layout: "fill",
                                    objectFit: "contain",
                                    draggable: false,
                                    alt: "chacra-signature"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                            flex: "1",
                            justifyContent: {
                                base: 'flex-start',
                                lg: 'flex-end'
                            },
                            spacing: "4",
                            py: {
                                base: 0,
                                lg: 8
                            },
                            order: {
                                base: 2,
                                lg: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Link */.rU, {
                                    bg: "white",
                                    _hover: {
                                        bg: 'primary',
                                        color: 'white'
                                    },
                                    width: "38px",
                                    height: "38px",
                                    rounded: "lg",
                                    href: "https://www.linkedin.com/company/chacrasoftware",
                                    isExternal: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_visually_hidden_esm/* VisuallyHidden */.TX, {
                                            children: "Chacra Software LinkedIn"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                                            h: "full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiLinkedinFill */.ExP, {
                                                size: 24
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Link */.rU, {
                                    bg: "white",
                                    _hover: {
                                        bg: 'primary',
                                        color: 'white'
                                    },
                                    width: "38px",
                                    height: "38px",
                                    rounded: "lg",
                                    href: "https://www.facebook.com/ChacraSoftware",
                                    isExternal: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_visually_hidden_esm/* VisuallyHidden */.TX, {
                                            children: "Chacra Software Facebook"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                                            h: "full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaFacebookF */.tBk, {
                                                size: 24
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Link */.rU, {
                                    bg: "white",
                                    _hover: {
                                        bg: 'primary',
                                        color: 'white'
                                    },
                                    width: "38px",
                                    height: "38px",
                                    rounded: "lg",
                                    href: "https://www.instagram.com/chacrasoftware",
                                    isExternal: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_visually_hidden_esm/* VisuallyHidden */.TX, {
                                            children: "Chacra Software Instagram"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                                            h: "full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsInstagram */.Vs6, {
                                                size: 24
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/Footer/index.ts



// EXTERNAL MODULE: ./src/assets/images/logo-green.png
var logo_green = __webpack_require__(9817);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/Header/HeaderLogo.tsx




var HeaderLogo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionBox */.uH, {
        h: "full",
        w: {
            base: '150px',
            md: '160px',
            lg: '180px'
        },
        position: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
            src: props.src,
            layout: "responsive",
            priority: true,
            alt: "chacra-logo"
        })
    });
};
/* harmony default export */ var Header_HeaderLogo = (HeaderLogo);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(2684);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/Header/HeaderNavButton.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var HeaderNavButton = function(_param) {
    var _theme = _param.theme, theme = _theme === void 0 ? 'light' : _theme, props = _objectWithoutProperties(_param, [
        "theme"
    ]);
    var color = theme === 'light' ? 'black' : 'white';
    var state = props.isOpen ? 'open' : 'closed';
    var y1 = (0,chakra_ui_media_query_esm/* useBreakpointValue */.Sx)({
        base: 2,
        md: 3
    });
    var bar1 = {
        closed: {
            rotate: 0,
            y: 0
        },
        open: function(y) {
            return {
                rotate: 45,
                y: y,
                marginBottom: 0
            };
        }
    };
    var bar2 = {
        closed: {
            rotate: 0,
            y: 0
        },
        open: function(y) {
            return {
                rotate: -45,
                y: -y
            };
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_button_esm/* Button */.zx, {
        "aria-label": "Nav Button",
        variant: "unstyled",
        rounded: 0,
        h: {
            base: '40px',
            md: '60px'
        },
        w: {
            base: '40px',
            md: '60px'
        },
        position: "relative",
        onClick: props.onClick,
        zIndex: 1301,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionBox */.uH, {
                variants: bar1,
                animate: state,
                custom: y1,
                w: {
                    base: '40px',
                    md: '60px'
                },
                h: {
                    base: '4px',
                    md: '6px'
                },
                bgColor: props.isOpen ? 'white' : color,
                mb: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionBox */.uH, {
                variants: bar2,
                animate: state,
                custom: y1,
                w: {
                    base: '40px',
                    md: '60px'
                },
                h: {
                    base: '4px',
                    md: '6px'
                },
                bgColor: props.isOpen ? 'white' : color
            })
        ]
    });
};
/* harmony default export */ var Header_HeaderNavButton = (HeaderNavButton);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/Header/HeaderNavLink.tsx
function HeaderNavLink_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeaderNavLink_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderNavLink_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var HeaderNavLink = function(props) {
    var _fontSize, _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: props.href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
            display: "block",
            fontSize: (_fontSize = props.fontSize) !== null && _fontSize !== void 0 ? _fontSize : {
                base: '2xl',
                md: '3xl',
                lg: '4xl'
            },
            textAlign: props.textAlign,
            fontWeight: "bold",
            textDecoration: props.textDecoration,
            color: (_color = props.color) !== null && _color !== void 0 ? _color : 'white',
            mt: props.mt,
            _hover: HeaderNavLink_objectSpread({
                color: 'primary'
            }, props._hover),
            isExternal: props.isExternal,
            children: props.children
        })
    });
};
/* harmony default export */ var Header_HeaderNavLink = (HeaderNavLink);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(5421);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/Header/HeaderNavMenu.tsx





var HeaderNavMenu = function(props) {
    var escFunction = (0,react.useCallback)(function(event) {
        if (event.keyCode === 27) {
            if (props.onClose) props.onClose();
        }
    }, [
        props
    ]);
    (0,react.useEffect)(function() {
        if (props.isOpen) {
            document.addEventListener('keydown', escFunction, false);
            document.body.style.overflow = 'hidden';
        }
        return function() {
            document.removeEventListener('keydown', escFunction, false);
            document.body.style.overflow = 'unset';
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.isOpen
    ]);
    var container = {
        closed: {
            opacity: 0,
            transition: {
                staggerChildren: 0.1,
                when: 'afterChildren',
                staggerDirection: -1
            }
        },
        open: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                when: 'beforeChildren'
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: props.isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionFlex */.HZ, {
            position: "absolute",
            top: 0,
            left: 0,
            h: "100vh",
            w: "full",
            zIndex: "overlay",
            variants: container,
            initial: "closed",
            animate: "open",
            exit: "closed",
            backgroundColor: props.backgroundColor,
            onClick: props.onClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* VStack */.gC, {
                w: "full",
                alignItems: "flex-end",
                pt: "120px",
                px: {
                    base: '4',
                    md: '6',
                    lg: '12'
                },
                spacing: 4,
                overflow: "hidden",
                children: props.children
            })
        }, "nav-menu-container")
    });
};
/* harmony default export */ var Header_HeaderNavMenu = (HeaderNavMenu);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/Header/HeaderNavMenuItem.tsx



var HeaderNavMenuItem = function(props) {
    var item = {
        closed: {
            x: '150%',
            transition: {
                duration: 0.5
            }
        },
        open: {
            x: '0%',
            transition: {
                duration: 0.5
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionBox */.uH, {
        variants: item,
        children: props.children
    });
};
/* harmony default export */ var Header_HeaderNavMenuItem = (HeaderNavMenuItem);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/Header/Header.tsx










var Header = function(props) {
    var ref = (0,react.useState)(false), isNavMenuOpen = ref[0], setIsNavMenuOpen = ref[1];
    var toggleNavMenuOpen = function() {
        return setIsNavMenuOpen(!isNavMenuOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        as: "header",
        position: "absolute",
        top: "0",
        left: "0",
        w: "full",
        justifyContent: "space-between",
        alignItems: "center",
        px: {
            base: '4',
            md: '6',
            lg: '12'
        },
        h: "100px",
        zIndex: "sticky",
        children: [
            props.noHeaderLogo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderLogo, {
                        src: logo_green/* default */.Z
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavButton, {
                isOpen: isNavMenuOpen,
                onClick: toggleNavMenuOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_HeaderNavMenu, {
                isOpen: isNavMenuOpen,
                onClose: toggleNavMenuOpen,
                backgroundColor: "rgba(0,0,0,0.7)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavMenuItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavLink, {
                            href: "/",
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavMenuItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavLink, {
                            href: "/posts",
                            children: "Blogs"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavMenuItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavLink, {
                            href: "/portfolio",
                            children: "Portfolio"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavMenuItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavLink, {
                            href: "/contact-us",
                            children: "Contact Us"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavMenuItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderNavLink, {
                            href: "https://www.clutch.co/profile/chacra-software-solutions-0#reviews",
                            isExternal: true,
                            children: "Clutch Reviews"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/Header/index.ts


;// CONCATENATED MODULE: ./src/layouts/MainLayout/MainLayout.tsx




var MainLayout = function(props) {
    var colorMode = (0,chakra_ui_color_mode_esm/* useColorMode */.If)().colorMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                noHeaderLogo: props.noHeaderLogo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                as: "main",
                zIndex: 1,
                position: "relative",
                bg: colorMode === 'dark' ? 'black' : 'white',
                transitionProperty: "background-color",
                transitionDuration: "0.3s",
                pt: props.noPaddingTop ? 0 : '100px',
                children: props.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                footerTheme: props.footerTheme,
                footerSticky: props.footerSticky
            })
        ]
    });
};
/* harmony default export */ var MainLayout_MainLayout = (MainLayout);

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var zustand_esm = __webpack_require__(4671);
;// CONCATENATED MODULE: ./src/layouts/MainLayout/useMainLayoutStore.ts

var useMainLayoutStore = (0,zustand_esm/* default */.Z)(function(set) {
    return {
        backgroundColor: '#fff',
        setBackgroundColor: function(color) {
            return set({
                backgroundColor: color
            });
        }
    };
});
/* harmony default export */ var MainLayout_useMainLayoutStore = ((/* unused pure expression or super */ null && (useMainLayoutStore)));

;// CONCATENATED MODULE: ./src/layouts/MainLayout/index.ts



;// CONCATENATED MODULE: ./src/layouts/index.ts




/***/ })

}]);